import { render, staticRenderFns } from "./ChangeRequestButton.vue?vue&type=template&id=e09b9468&"
import script from "./ChangeRequestButton.vue?vue&type=script&lang=js&"
export * from "./ChangeRequestButton.vue?vue&type=script&lang=js&"
import style0 from "./ChangeRequestButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports